export const badgesColor = {
  green: 'custom-badges_green',
  grey: 'custom-badges_grey',
  yellow: 'custom-badges_yellow'
}